<template>
	<div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Dashboard</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Dashboard</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
                
				<div class="custom-container">

					<div class="row">
						
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
							<Sidebar />
						</div>
						<!-- / Profile Sidebar -->
						
						<div class="col-md-7 col-lg-8 col-xl-9 theiaStickySidebar">
							<div class="row">
								<div class="col-md-8">

									<div class="card booking-card">
										<div class="card-header">
											<h4 class="card-title">Checkout</h4>
										</div>
										<div class="card-body">
											<!-- <div class="info-widget">
												<h4 class="card-title">Masukan Kode Promo</h4>
												<div class="row">
													<div class="col-md-12 col-sm-12">
															<input class="form-control" type="text">
													</div>
												</div>
											</div> -->

											<!-- Booking Doctor Info -->
											<!-- <div class="booking-doc-info">
												<router-link to="/profile" class="booking-doc-img">
													<img src="@/assets/img/schools/school-1.jpg" alt="User Image">
												</router-link>
												<div class="booking-info">
													<h4><router-link to="/profile"> Camestone School</router-link></h4>
													<div class="rating">
														<i class="fas fa-star filled"></i>
														<i class="fas fa-star filled"></i>
														<i class="fas fa-star filled"></i>
														<i class="fas fa-star filled"></i>
														<i class="fas fa-star"></i>
														<span class="d-inline-block average-rating">35</span>
													</div>
													<div class="shop-details">
														<p class="doc-location"><i class="fas fa-map-marker-alt"></i> Newyork, USA</p>
													</div>
												</div>
											</div> -->
											<!-- Booking Doctor Info -->
											
											<div class="booking-summary">
												<h4 class="card-title">Rincian Pembelian</h4>

												<div class="booking-item-wrap">
													<!-- <ul class="booking-date">
														<li>Date <span>16 Nov 2019</span></li>
														<li>Time <span>10:00 AM</span></li>
													</ul> -->
													<ul class="booking-fee">
														<li>Nama Paket <span>{{paket.nama_paket}}</span></li>
														<li>Harga 
															<span>
																<span class="font-semibold text-base text-gray-900">Rp {{paket.harga_aktif_awal_curr}}</span>
																<span class="font-medium text-xs sm:text-sm text-red-600 mr-1"><del>Rp {{paket.harga_awal_curr}}</del></span> 
																
															</span>    
														</li>
														<li>Diskon Referral <span>Rp {{(referral.diskon_referral_curr=="0")?"-":referral.diskon_referral_curr}}</span></li>

													</ul>
													<div class="booking-total">
														<ul class="booking-total-list">
															<li>
																<span>Kode Referral</span>
																<span class="total-cost">
																	<div class="row">						
																		<div class="col-sm-8">
																			<input type="text" class="form-control" v-model="referral.kode_referral" @change="getReferral()"/>
																			
																		</div>
																		<div class="col-sm-4">
																			<button type="button" name='cekReferral' id='cekReferral' class='btn btn-warning btn-block' @click.prevent="getReferral()">
																			Cek
																			</button>
																		</div>
																	</div>
                                        							<!-- <input class="form-control" type="text" v-model="paket.kode_referral" @change="getReferral()">
																	<button>cek</button> -->
																</span>
																<br>
																<span class="font-medium text-xs sm:text-sm badge badge-pill bg-warning-light" :class="{'text-red-600': referral.status=='2'}"> {{referral.kode_referral_pesan}}</span>
																<br>
															</li>
															<!-- <li>
															</li> -->
														</ul>
													</div>
													<div class="booking-total">
														<ul class="booking-total-list">
															<li>
																<span>Total</span>
																<span class="total-cost">Rp {{paket.harga_aktif_curr}}</span>
															</li>
														</ul>
													</div>
												
												</div>
											</div>
										</div>
										
										<div class="card-footer">
											<!-- Submit Section -->
											<div class="text-center">												
												<button class="btn btn-primary" @click.prevent="createInvoice(paket)" :disabled="loading">
													Checkout
												</button>	
											</div>
										</div>
									</div>
								</div>
								<div class="col-md-4">
 									<div class="card widget-profile pat-widget-profile">
										<div class="card-body">
											<div class="paket-widget-content" v-bind:style="{ backgroundImage: 'url(' + paket.url_gambar + ')' }">
											</div>
										</div>
										<!-- <div class="card-footer text-center">
											<btn class="btn btn-fill-blue" @click.prevent="doCheckout(paket)">
												Checkout
											</btn>											
										</div> -->
									 </div>
								</div>
							</div>
							
						</div>
                    </div>

				</div>

			</div>		
			<!-- /Page Content -->
   
			<!-- Footer -->
                <layout-footer />
			<!-- /Footer -->
		</div>
		
	</div>
		<!-- /Main Wrapper -->
</template>


<script>
// import instructors from '../../../assets/json/instructorslist'
// const images = require.context('@/assets/img/clients', false, /\.png$|\.jpg$/)
// import schoolvisits from '../../../assets/json/instructor/dashboard/schoolvisits'
// import coursetakenrecords from '../../../assets/json/instructor/dashboard/coursetakenrecords'
// import billing from '../../../assets/json/instructor/dashboard/billing'

import Sidebar from '../../Sidebar'
import axios from 'axios';
import axiosXendit from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery'
import moment from 'moment'

export default {
    components: {
        Sidebar
    },
	name: 'paket-belajar',
    // vuetify: new Vuetify(),
    data() {
        return {
			loading: false,
			external_id: '',
            lstpaket: [],
			referral:{
                komisi_referral: '',
                komisi_referral_pesan: '',
                komisi_referral_status: '',
                diskon_referral: '',
                diskon_referral_curr: '',
				harga_aktif: '',
				harga_aktif_curr: '',			
				kode_referral: '',
				kode_referral_pesan: '',
				status:''
			},
            paket:{
                id_paket: '',
                nama_paket: '',
                tipe_paket: '',
                harga_awal: '',
                harga_awal_curr: '',
                diskon: '',
				harga_aktif: '',
				harga_aktif_curr: '',
				harga_aktif_awal: '',
				harga_aktif_awal_curr: '',
                masa_berlaku: '',
				jml_to: '',
                diskon_referral: '',
                diskon_referral_curr: '',
                komisi_referral: '',
                komisi_referral_pesan: '',
                komisi_referral_status: '',
                url_gambar: '',
                fg_publish: '',
                fg_pendaftaran: '',
                fg_favorit: '',
                url_telegram: '',
                slot: '',
				kode_referral: '',
				kode_referral_pesan: '',
				status:''

            },
            lsttipe: [
                {id: '1', text: 'MANDIRI'},
                {id: '2', text: 'BIMBEL'}
            ],
            lststspublish: [
                {id: '1', text: 'DRAFT'},
                {id: '2', text: 'PUBLISH'}
            ],
            lststspendaftaran: [
                {id: '1', text: 'DITUTUP'},
                {id: '2', text: 'DIBUKA'}
            ],
            lststsfav: [
                {id: '1', text: 'TIDAK'},
                {id: '2', text: 'YA'}
            ],
			lstbenefit: [],
			lstjadwal: [],
			lsttryout: [],
			paketlsttryout: [],
			lstmateri: [],
			paketlstmateri: [],
            //     {id_paket_benefit: '1', nama_benefit: 'Benefit 1'},
			// ]
            // lstmateri: [],
            // materi:{
            //     id_materi: '',
            //     id_tingkatan: '',
            //     nama_materi: '',
            // },
            // lstsubmateri: [],
            // submateri: {
            //     id_sub_materi: '',
            //     id_materi: '',
            //     nama_sub_materi: '',
            // },
        }
    },
    created: function () {
        // this.refreshAll();
        
		this.referral.kode_referral = localStorage.getItem("vkode_referral");
		this.getReferral();
        this.getPaket();
        // this.getAllMateri();
        // this.getAllSub();
        // this.initDt("tblMateri");
        // this.initDt("tblSub");

    },  

    methods: {
        
        getPaket: function () {
            axios.get('api/paketbelajar/'+localStorage.getItem('idUser')+'/'+localStorage.getItem("idPaket"))//this.$route.params.id)
                .then(res => {
                    // console.log(res.data);
                    this.paket = res.data.data;
					if(this.referral.status == '1'){					
						this.paket.harga_aktif_awal = this.referral.harga_aktif;
						this.paket.harga_aktif_awal_curr = this.referral.harga_aktif_curr;
					} else {
						this.paket.harga_aktif_awal = this.paket.harga_aktif;
						this.paket.harga_aktif_awal_curr = this.paket.harga_aktif_curr;
					}
					// this.paket.kode_referral = localStorage.getItem("vkode_referral");
					// this.paket.kode_referral_pesan = "ayo masukan kode referral untuk mendapatkan diskon";
					// this.getReferral();
                    // this.initDt("tblLatihan");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

		 
        getReferral: function () {
			var self = this;
			
            axios.post('api/getReferral', {
                        id_paket: localStorage.getItem("idPaket"), //this.$route.params.id,
						kode_referral: this.referral.kode_referral // this.paket.kode_referral
                    })
                .then(res => {
					var ref = res.data.data;
					self.referral.status = ref.status;
					self.referral.kode_referral = ref.kode_referral;
					self.referral.kode_referral_pesan = res.data.data.pesan;
					// console.log(self.paket.kode_referral_pesan);
					self.referral.komisi_referral = ref.komisi_referral;
					self.referral.diskon_referral = ref.diskon_referral;
					self.referral.diskon_referral_curr = ref.diskon_referral_curr;
					self.referral.harga_aktif = ref.harga_aktif_ori;
					self.referral.harga_aktif_curr = ref.harga_aktif_curr;
					self.paket.harga_aktif = ref.harga_aktif_ori;
					self.paket.harga_aktif_curr = ref.harga_aktif_curr;
					// var ref = res.data.data;
                    // console.log(data);
					// if(data){
					// self.$nextTick(function() {
						// self.paket.status = res.data.data.status;
						// self.paket.kode_referral = ref.kode_referral;
						// self.paket.kode_referral_pesan = 'abc';//res.data.data.pesan;
						// console.log(self.paket.kode_referral_pesan);
						// self.paket.diskon_referral = ref.diskon_referral;
						// self.paket.diskon_referral_curr = ref.diskon_referral_curr;
						// self.paket.harga_aktif = ref.harga_aktif_ori;
						// self.paket.harga_aktif_curr = ref.harga_aktif_curr;
					// })
					// if(ref.status == '1'){
					// this.paket.status = ref.status;
					// this.paket.kode_referral = ref.kode_referral;
					// this.paket.kode_referral_pesan = ref.pesan;
					// console.log(this.paket.kode_referral_pesan);
					// this.paket.diskon_referral = ref.diskon_referral;
					// this.paket.diskon_referral_curr = ref.diskon_referral_curr;
					// this.paket.harga_aktif = ref.harga_aktif_ori;
					// this.paket.harga_aktif_curr = ref.harga_aktif_curr;
					// } else{
					// 	this.paket.status = "2";
					// 	this.paket.kode_referral_pesan = "Kode Referral tidak ditemukan";
					// 	console.log(this.paket.kode_referral_pesan);
					// 	this.paket.diskon_referral = 0;
					// 	this.paket.diskon_referral_curr = "-";
					// 	this.paket.harga_aktif = this.paket.harga_aktif_awal;
					// 	this.paket.harga_aktif_curr = this.paket.harga_aktif_awal_curr;
					// }
                    // this.initDt("tblLatihan");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
			// } else {
			// 	this.paket.kode_referral_pesan = 'ayo masukan kode referral untuk dapat diskonnya';
			// 	this.paket.diskon_referral = 0;
			// 	this.paket.diskon_referral_curr = '0';
			// 	this.paket.harga_aktif = data.harga_aktif_ori;
			// 	this.paket.harga_aktif_curr = data.harga_aktif_curr;

			// }
        },

		
        createInvoice: function (paket) {
			// this.getReferral();
			// console.log("masuk ke create invoice 4" + this.paket.harga_aktif);
			this.loading = true;
			this.external_id = "INV-"+Date.now();
			var self = this;
			
            axios.post('api/getReferral', {
                        id_paket: localStorage.getItem("idPaket"), //this.$route.params.id,
						kode_referral: this.referral.kode_referral // this.paket.kode_referral
                    })
                .then(res => {
					var ref = res.data.data;
					self.referral.status = ref.status;
					self.referral.kode_referral = ref.kode_referral;
					self.referral.kode_referral_pesan = res.data.data.pesan;
					// console.log(self.paket.kode_referral_pesan);
					self.referral.komisi_referral = ref.komisi_referral;
					self.referral.diskon_referral = ref.diskon_referral;
					self.referral.diskon_referral_curr = ref.diskon_referral_curr;
					self.referral.harga_aktif = ref.harga_aktif_ori;
					self.referral.harga_aktif_curr = ref.harga_aktif_curr;
					self.paket.harga_aktif = ref.harga_aktif_ori;
					self.paket.harga_aktif_curr = ref.harga_aktif_curr;
					
					if(self.paket.id_paket){
						axios.post('api/invoice', {
							id_user: localStorage.getItem('idUser'),
							id_paket: self.paket.id_paket,
							external_id: self.external_id,
							purchase_date: moment(String(new Date())).format('YYYY-MM-DD hh:mm:ii'),
							nama_paket: self.paket.nama_paket,
							tipe: self.paket.tipe_paket,
							price: self.paket.harga_aktif,
							harga_awal: self.paket.harga_awal,
							diskon: self.paket.diskon,
							kode_referral: (self.referral.diskon_referral>0)?self.referral.kode_referral:'',
							diskon_referral: self.referral.diskon_referral,
							komisi_referral: self.referral.komisi_referral
						})
						.then(res => {
							// handle success
							// localStorage.removeItem('idPaket');
							localStorage.setItem("idPaket",  res.data.data); 
							self.loading = false;
							if(parseInt(self.paket.harga_aktif) >0)
								self.$router.push({name:'siswa-paket-belajar-invoice'});//, params: {id: res.data.data}}); 
							else
								self.$router.push({name:'siswa-paket-belajar-invoice-gratis'});//, params: {id: res.data.data}}); 
								
							
						})
						.catch(err => {
							// handle error
							console.log(err);
							self.loading = false;

						})
					}
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })

			// if(this.paket.id_paket){
			// 	axios.post('api/invoice', {
			// 		id_user: localStorage.getItem('idUser'),
			// 		id_paket: this.paket.id_paket,
			// 		external_id: this.external_id,
			// 		purchase_date: moment(String(new Date())).format('YYYY-MM-DD hh:mm:ii'),
			// 		nama_paket: this.paket.nama_paket,
			// 		tipe: this.paket.tipe_paket,
			// 		price: this.paket.harga_aktif,
			// 		harga_awal: this.paket.harga_awal,
			// 		diskon: this.paket.diskon,
			// 		kode_referral: this.referral.kode_referral,
			// 		diskon_referral: this.referral.diskon_referral,
			// 		komisi_referral: this.referral.komisi_referral
			// 	})
			// 	.then(res => {
			// 		// handle success
			// 		// localStorage.removeItem('idPaket');
			// 		localStorage.setItem("idPaket",  res.data.data); 
			// 		this.loading = false;
			// 		if(parseInt(this.paket.harga_aktif) >0)
			// 			this.$router.push({name:'siswa-paket-belajar-invoice'});//, params: {id: res.data.data}}); 
			// 		else
			// 			this.$router.push({name:'siswa-paket-belajar-invoice-gratis'});//, params: {id: res.data.data}}); 
						
					
			// 	})
			// 	.catch(err => {
			// 		// handle error
			// 		console.log(err);
			// 		this.loading = false;

			// 	})
			// }

			// if(parseInt(this.paket.harga_aktif) >0){
			// 	var instance = axiosXendit.create({ baseURL: 'https://api.xendit.co/' });
			// 	// instance.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
			// 	// instance.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

			// 	// instance.get('/myPath', { timeout: 5000 });
			// 	this.external_id = "INV-"+Date.now();
			// 	instance.post('v2/invoices',{
			// 				external_id: this.external_id,
			// 				amount: this.paket.harga_aktif,
			// 				payer_email: "siswa@gmail.com",
			// 				description: this.paket.nama_paket,
			// 				items: [
			// 						{
			// 							name: this.paket.nama_paket,
			// 							quantity: 1,
			// 							price: this.paket.harga_aktif,
			// 							category: this.paket.nama_tipe,
			// 							url: 'https=>//yourcompany.com/example_item'
			// 						}
			// 				]
			// 			},
			// 			{
			// 				headers: 
			// 				{
			// 					// "Access-Control-Allow-Origin": '*',
			// 					// 'Content-type': 'application/json',
			// 					Authorization: 'Basic eG5kX2RldmVsb3BtZW50X2NXaE85TU85WFM3R3VTUnJMU2RycVp5WkNyN0RVdURwcnJTandiVGszV2lKWlYzOE54eXBmMUprR3FURlU1Og=='
			// 				}
			// 			}
			// 		)
			// 		.then(res => {
			// 			// console.log("ini hasil create invoice");
			// 			// console.log(res.data);
			// 			axios.post('api/invoice', {
			// 				id_user: localStorage.getItem('idUser'),
			// 				id_paket: this.paket.id_paket,
			// 				external_id: this.external_id,
			// 				inv_id: res.data.id,
			// 				purchase_date: res.data.created,
			// 				expired_date: res.data.expiry_date,
			// 				metode_bayar_id: '' ,
			// 				metode_bayar_lbl: '',
			// 				payer_email:  localStorage.getItem('emailUser'),
			// 				nama_paket: this.paket.nama_paket,
			// 				tipe: this.paket.tipe_paket,
			// 				price: this.paket.harga_aktif,
			// 				status: 'PENDING',
			// 				harga_awal: this.paket.harga_awal,
			// 				diskon: this.paket.diskon,
			// 				kode_referral: this.paket.kode_referral,
			// 				diskon_referral: this.paket.diskon_referral,
			// 				komisi_referral: this.paket.komisi_referral
			// 			})
			// 			.then(res => {
			// 				// handle success
            //     			// localStorage.removeItem('idPaket');
            // 				// localStorage.setItem("idPaket",  res.data.data); 
			// 				this.$router.push({name:'siswa-paket-belajar-invoice', params: {id: res.data.data}}); 
							
			// 			})
			// 			.catch(err => {
			// 				// handle error
			// 				console.log(err);
			// 				this.loading = false;

			// 			})
						
			// 		})
			// 		.catch(err => {
			// 			// handle error
			// 			console.log(err);
			// 				this.loading = false;

			// 		})

			// } else {
			// 		// this.$router.push({name:'siswa-paket-belajar-invoice-gratis', params: {id: 9}}); 

			// 		axios.post('api/invoice', {
			// 			id_user: localStorage.getItem('idUser'),
			// 			id_paket: this.paket.id_paket,
			// 			external_id: '', 
			// 			inv_id: '',
			// 			purchase_date: moment(String(new Date())).format('YYYY-MM-DD hh:mm:ii'),
			// 			expired_date: '',
			// 			metode_bayar_id: '',
			// 			metode_bayar_lbl: '',
			// 			payer_email:  localStorage.getItem('emailUser'),
			// 			nama_paket: this.paket.nama_paket,
			// 			tipe: this.paket.tipe_paket,
			// 			price: this.paket.harga_aktif,
			// 			status: 'PAID',
			// 			harga_awal: this.paket.harga_awal,
			// 			diskon: this.paket.diskon,
			// 			kode_referral: this.paket.kode_referral,
			// 			diskon_referral: this.paket.diskon_referral,
			// 			komisi_referral: this.paket.komisi_referral
			// 		})
			// 		.then(res => {
			// 			// handle success
            // 			localStorage.setItem("idPaket",  res.data.data); 
			// 			this.$router.push({name:'siswa-paket-belajar-invoice-gratis'});//, params: {id: res.data.data}}); 
						
			// 		})
			// 		.catch(err => {
			// 			// handle error
			// 			console.log(err);
			// 			this.loading = false;

			// 		})
			// }

        },

		
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Siswa/PaketBelajar/SummaryCheckout/index.vue